import React from "react";
import { ExternalLink, ExternalLinkProps } from "./ExternalLink";
import { privacyPolicyUrl } from "./urls";

export const PrivacyPolicyLink = (props: ExternalLinkProps) => (
  <ExternalLink href={privacyPolicyUrl} label={"Privacy Policy"} {...props} />
);
